function isPositiveInteger(value) {
  if (value === null || value === undefined || value === "") {
    return false;
  }

  const normalized = Number(value);
  return Number.isInteger(normalized) && normalized > 0;
}

export function validateSharedGameForm({
  form,
  t,
  notify,
  requireDiscipline = true,
  requireTitle = false,
}) {
  if (form.imageUploading) {
    notify(t("image-upload-wait"));
    return false;
  }

  if (!form.hostName) {
    notify(t("error-host-name"));
    return false;
  }

  if (form.hostName.length > 16) {
    notify(t("error-host-length"));
    return false;
  }

  if (!form.allowedPlayers) {
    notify(t("error-allowed-players"));
    return false;
  }

  if (!isPositiveInteger(form.allowedPlayers)) {
    notify(t("error-valid-players"));
    return false;
  }

  if (!form.groupLimit) {
    notify(t("error-group-limit"));
    return false;
  }

  if (!isPositiveInteger(form.groupLimit)) {
    notify(t("error-valid-group-limit"));
    return false;
  }

  if (!form.readingTime) {
    notify(t("error-reading-time"));
    return false;
  }

  if (!isPositiveInteger(form.readingTime)) {
    notify(t("error-valid-reading"));
    return false;
  }

  if (!form.discussionTime) {
    notify(t("error-discussion-time"));
    return false;
  }

  if (!isPositiveInteger(form.discussionTime)) {
    notify(t("error-valid-discussion"));
    return false;
  }

  if (requireDiscipline && !form.discipline) {
    notify(t("error-discipline"));
    return false;
  }

  if (form.discipline === "code" && !form.codeLanguage) {
    notify(t("error-code-language"));
    return false;
  }

  if (requireTitle && !form.title) {
    notify(t("error-title"));
    return false;
  }

  return true;
}
